//ltv to premium, based on information from CMHC, assuming brrr and buy and hold have rental premiums and a flip is the normal premium
const CMHCInsurancePremiums = {
  rental: {
    0.85: 0.0535,
    0.8: 0.0435,
    0.75: 0.0335,
    0.7: 0.0285,
    0.65: 0.026,
  },
  flip: {
    0.75: 0.017,
    0.8: 0.024,
    0.85: 0.028,
    0.9: 0.031,
    0.95: 0.04,
  },
};

export default CMHCInsurancePremiums;
